"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const WidgetButton = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 20, height: 12, x: 2, y: 4, fill: "#716BF1", className: styles.accentColor, rx: 2 }),
    /* @__PURE__ */ React.createElement("rect", { width: 12, height: 2, x: 6, y: 9, fill: "#fff", opacity: 0.4, rx: 1 }),
    /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.5 19.641V11.25l6.124 6.137h-2.77l1.71 4.064-1.384.581-1.777-4.228z" })
  );
};
export default WidgetButton;
